// extracted by mini-css-extract-plugin
export default {"cuttingEdge":"CuttingEdge_cuttingEdge__6QCe-","container":"CuttingEdge_container__jd12X"};